export const MIN_TOKEN_DURATION_MS = 10;
export const AXIS_HEIGHT = 30;
